import dynamic from 'next/dynamic'
import { useMemo } from 'react'
import { HashRouter, Route, Routes } from 'react-router-dom'

import ProtectedRoutes from '@/components/protected-routes/protected-routes'
import { PreselectedStoreToast } from '@/features/stores/preselected-store-toast'

const ProductListPage = dynamic(
  () =>
    import('@/features/product-list/product-list-page').then(
      (mod) => mod.ProductListPage
    ),
  { ssr: false }
)

export function ViewRouter() {
  const CancellationPage = useMemo(
    () =>
      dynamic(
        () =>
          import('@/features/cancellation/page').then(
            (mod) => mod.CancellationPage
          ),
        { ssr: false }
      ),
    []
  )

  const ReservationSummaryPage = useMemo(
    () =>
      dynamic(
        () =>
          import(
            '@/features/reservation-summary/reservation-summary-page'
          ).then((mod) => mod.ReservationSummaryPage),
        { ssr: false }
      ),
    []
  )

  const ProductDetailPage = useMemo(
    () =>
      dynamic(
        () =>
          import('@/features/product-details/product-detail-page').then(
            (mod) => mod.ProductDetailPage
          ),
        { ssr: false }
      ),
    []
  )

  const ThankYouPage = useMemo(
    () =>
      dynamic(
        () =>
          import('@/features/thank-you-page/thank-you-page').then(
            (mod) => mod.ThankYouPage
          ),
        { ssr: false }
      ),
    []
  )

  return (
    <HashRouter>
      <Routes>
        <Route path="/">
          <Route path=":listOfStores">
            <Route path=":offerNumber">
              <Route index element={<ProductDetailPage />} />
              <Route element={<ProtectedRoutes />}>
                <Route path="cancellation" element={<CancellationPage />} />
                <Route
                  path="reservation-summary"
                  element={<ReservationSummaryPage />}
                />
                <Route path="thank-you" element={<ThankYouPage />} />
              </Route>
            </Route>
            <Route index element={<ProductListPage />} />
          </Route>
          <Route
            index
            element={
              <>
                <PreselectedStoreToast />
                {<ProductListPage />}
              </>
            }
          />
          <Route element={<ProtectedRoutes />}>
            <Route
              path=":offerNumber/cancellation"
              element={<CancellationPage />}
            />
          </Route>
        </Route>
      </Routes>
    </HashRouter>
  )
}
